import { render, staticRenderFns } from "./EbookEmptyState.vue?vue&type=template&id=1bf7d8da&scoped=true&"
import script from "./EbookEmptyState.vue?vue&type=script&lang=js&"
export * from "./EbookEmptyState.vue?vue&type=script&lang=js&"
import style0 from "./EbookEmptyState.vue?vue&type=style&index=0&id=1bf7d8da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf7d8da",
  null
  
)

export default component.exports